<Modal :value="visible" :title="title" :width="65" :closable="false" :mask-closable="false" :scrollable="true"
    :mask="true">
    <Row style="padding-bottom:10px;">
        <Col>
        <Input v-model="name" @on-enter="pageChange(1)" clearable style="width: 150px"></Input>
        <Button type="primary" icon="ios-search" @click="pageChange(1)">搜索</Button>
        </Col>
    </Row>
    <Row v-if="multiple">
        <Col>
        <Tag size="medium" v-for="user in users" :name="user.id" @on-close="handleSelectTagClose" closable
            :key="user.id"> {{user.fullName}}</Tag>
        </Col>
    </Row>
    <Row class="searchable-table-con1 margin-top-10">
        <Col>
        <Table size="small" :loading="loading" :columns="userColumns" v-if="reloadUser" @on-select="handleSelect"
            @on-select-all="handleSelectAll" @on-select-cancel="handleSelectCancel"
            @on-select-all-cancel="handelSelectAllCancel" :border="true" stripe :data="allUsers"></Table>
        <Page :total="totalCount" class="margin-top-10" @on-change="pageChange" :page-size="pageSize"
            :current="currentPage"></Page>
        </Col>
    </Row>
    <div slot="footer">
        <Button @click="handelCancelClick">取消</Button>
        <Button v-if="multiple" type="primary" @click="handleOkClick">确定</Button>
    </div>
</Modal>
